import {inject, Injectable} from '@angular/core';
import {MessageService} from 'primeng/api';


@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {
  messageService = inject(MessageService);

  showGenericPermanentError(message: string): void {
    this.messageService.add({
      icon: 'fa-regular fa-triangle-exclamation py-0.5',
      severity: 'error',
      summary: 'An Error Has Occurred',
      detail: message,
      sticky: true
    });
  }

  showTemporaryError(message: string, durationMilliseconds?: number): void {
    this.messageService.add({
      icon: 'fa-regular fa-triangle-exclamation py-0.5',
      severity: 'error',
      summary: 'An Error Has Occurred',
      detail: message,
      life: durationMilliseconds ?? 3000,
    });
  }

  showTemporaryErrorWithTitle(title: string, message: string, durationMilliseconds?: number): void {
    this.messageService.add({
      icon: 'fa-regular fa-triangle-exclamation py-0.5',
      severity: 'error',
      summary: title,
      detail: message,
      life: durationMilliseconds ?? 3000,
    });
  }

  showWarningMessage(message: string, title?: string, durationMilliseconds?: number): void {
    this.messageService.add({
      icon: 'fa-regular fa-circle-exclamation py-0.5',
      severity: 'warn',
      summary: title ?? 'Warning',
      detail: message,
      life: durationMilliseconds ?? 3000,
    });
  }
}
